"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormTimeSelect", {
    enumerable: true,
    get: function() {
        return FormTimeSelect;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _FormInputGroupContext = require("../FormInputGroup/FormInputGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _Theme = require("../../../contexts/Theme");
const _luxon = require("luxon");
const _useClockIconBackground = require("./useClockIconBackground");
const _localisationeq1 = require("@equiem/localisation-eq1");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormTimeSelect = (param)=>{
    let { diffMinutes, startTime, endTime, setFieldValue, type, defaultOptionValue = "Start time", defaultOptionDisabled = true, timeFormat = "h:mma", language, ...props } = param;
    const { i18n } = (0, _localisationeq1.useTranslation)();
    const [localValue, setLocalValue] = (0, _react.useState)(typeof props.value === "number" ? props.value : 0);
    const value = Number(props.value) > 0 ? props.value : localValue;
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const fontColor = value === 0 ? colors.muted1 : "inherit";
    const dropdownBg = (0, _useClockIconBackground.useClockIconBackground)({
        color: value === 0 ? colors.muted1 : "#333"
    });
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded: props.rounded
    });
    const padding = (0, _useInputPadding.useInputPadding)({
        right: "32px"
    });
    const { hasSuffix } = (0, _react.useContext)(_FormInputGroupContext.FormInputGroupContext);
    const options = (0, _react.useMemo)(()=>{
        let start = _luxon.DateTime.now();
        let end = _luxon.DateTime.now();
        start = start.set({
            hour: startTime.hour,
            minute: startTime.minute,
            second: 0,
            millisecond: 0
        });
        end = end.set({
            hour: endTime.hour,
            minute: endTime.minute,
            second: 0,
            millisecond: 0
        });
        const res = [];
        while(start.toSeconds() < end.toSeconds()){
            res.push(start.toSeconds());
            // fail safe so there's no way we can trigger an infinite loop even with horrifically bad input
            start = start.plus({
                minutes: Math.max(Math.floor(diffMinutes), 1)
            });
        }
        res.push(end.toSeconds());
        return res;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        startTime.hour,
        startTime.minute,
        endTime.hour,
        endTime.minute,
        diffMinutes,
        timeFormat
    ]);
    (0, _react.useEffect)(()=>{
        if (type === "create" && setFieldValue != null && props.value === 0) {
            const currentTime = _luxon.DateTime.local().toSeconds();
            const closestTime = options.reduce((a, b)=>{
                return Math.abs(a - currentTime) < Math.abs(b - currentTime) ? a : b;
            });
            let closest = 0;
            closest = closestTime;
            if (closestTime <= currentTime && closestTime !== options[options.length - 1]) {
                closest = _luxon.DateTime.fromSeconds(closestTime).plus({
                    minutes: 15
                }).toSeconds();
            }
            setFieldValue("startTime", closest);
            setLocalValue(closest);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        language
    ]);
    const localisedOptions = (0, _react.useMemo)(()=>options.map((time)=>{
            return /*#__PURE__*/ _react.default.createElement("option", {
                value: time,
                key: time
            }, _localisationeq1.formatters.timeshort(_luxon.DateTime.fromSeconds(time), language !== null && language !== void 0 ? language : i18n.language));
        }), [
        language,
        options,
        i18n.language
    ]);
    var _props_id, _props_className;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("select", {
        ...props,
        id: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        "aria-describedby": hintId,
        onChange: (e)=>{
            setLocalValue(Number(e.target.value));
            if (props.onChange != null) {
                props.onChange(e);
            }
        },
        className: _style.default.dynamic([
            [
                "bbc0d64534e3b2e7",
                [
                    padding.shorthand,
                    fontColor,
                    dropdownBg,
                    hasSuffix ? "0" : "11px",
                    padding.top,
                    padding.bottom
                ]
            ]
        ]) + " " + "".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(borderCss.className)
    }, /*#__PURE__*/ _react.default.createElement("option", {
        value: 0,
        disabled: defaultOptionDisabled,
        className: _style.default.dynamic([
            [
                "bbc0d64534e3b2e7",
                [
                    padding.shorthand,
                    fontColor,
                    dropdownBg,
                    hasSuffix ? "0" : "11px",
                    padding.top,
                    padding.bottom
                ]
            ]
        ])
    }, defaultOptionValue), localisedOptions), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "bbc0d64534e3b2e7",
        dynamic: [
            padding.shorthand,
            fontColor,
            dropdownBg,
            hasSuffix ? "0" : "11px",
            padding.top,
            padding.bottom
        ]
    }, "select.__jsx-style-dynamic-selector{line-height:22px;padding:".concat(padding.shorthand, ";-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;display:inline-block;cursor:pointer;float:none;outline:none;width:100%;font-size:14px;color:").concat(fontColor, ";background:").concat(dropdownBg, " right ").concat(hasSuffix ? "0" : "11px", " center/16px 16px no-repeat;-o-text-overflow:ellipsis;text-overflow:ellipsis}select.__jsx-style-dynamic-selector option{color:#333}select.__jsx-style-dynamic-selector:first-child{padding-top:").concat(padding.top, "}select.__jsx-style-dynamic-selector:last-child{padding-bottom:").concat(padding.bottom, "}")), borderCss.styles);
};

//# sourceMappingURL=FormTimeSelect.js.map